import React from 'react';
import Styles from './ServiceOptionCard.module.scss';
import { getTranslation } from '../../RecommendedOptionsUtils';

const ItemsCounter = ({
  count,
  parentCallBack,
  maxLimit,
  handleClick,
  translations,
  cartLoading
}: any) => {
  const increment = (count: number) => {
    if (count < maxLimit) {
      parentCallBack.setCount(count + 1);
      handleClick(count + 1);
    } else {
      parentCallBack.setCount(count);
    }
  };
  const decrement = (count: number) => {
    if (count > 0) {
      parentCallBack.setCount(count - 1);
      handleClick(count - 1);
    } else {
      parentCallBack.setCount(count);
    }
  };

  const handleClickCounter = (e: any) => {
    e.target.id === 'increment' ? increment(count) : decrement(count);
  };
  return (
    <div className={Styles.counter}>
      <div className={`${Styles.countwrapper} ${cartLoading ? Styles.disabled : ''}`}>
        <label className={Styles.label}>
          {getTranslation(translations, 'quantity') ?? 'Quantity'}
        </label>
        <div className={Styles.controls}>
          <span
            className={`${Styles.decrementsign} ${count <= 0 ? Styles.disabled : ''}`}
            id='decrement'
            onClick={(e: any) => {
              count > 0 && handleClickCounter(e);
            }}
          ></span>
          <div className={Styles.count}>{count}</div>
          <span
            className={`${Styles.incrementsign} ${count >= maxLimit ? Styles.disabled : ''}`}
            id='increment'
            onClick={(e: any) => {
              count < maxLimit && handleClickCounter(e);
            }}
          ></span>
        </div>
      </div>
    </div>
  );
};

export default ItemsCounter;
